module.exports = __webpack_public_path__ + "img/gravier_bleu.48c1cb3d.jpg";